import React from "react";
import {
  Box,
  Typography,
  GridLegacy as Grid,
  Card,
  CardContent,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  CloudDownload as CloudDownloadIcon,
  Sync as SyncIcon,
  DataObject as DataObjectIcon,
  Analytics as AnalyticsIcon,
  Storage as StorageIcon,
  SwapHoriz as SwapHorizIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function Dataengineering() {
  const { t } = useTranslation();
  const dataengineeringT = (key: string) => t(`dataengineering:${key}`);

  const services = [
    {
      icon: <CloudDownloadIcon color="primary" fontSize="large" />,
      title: dataengineeringT("dataService1Title"),
      desc: dataengineeringT("dataService1Desc")
    },
    {
      icon: <SyncIcon color="primary" fontSize="large" />,
      title: dataengineeringT("dataService2Title"),
      desc: dataengineeringT("dataService2Desc")
    },
    {
      icon: <DataObjectIcon color="primary" fontSize="large" />,
      title: dataengineeringT("dataService3Title"),
      desc: dataengineeringT("dataService3Desc")
    },
    {
      icon: <AnalyticsIcon color="primary" fontSize="large" />,
      title: dataengineeringT("dataService4Title"),
      desc: dataengineeringT("dataService4Desc")
    },
    {
      icon: <StorageIcon color="primary" fontSize="large" />,
      title: dataengineeringT("dataService5Title"),
      desc: dataengineeringT("dataService5Desc")
    },
    {
      icon: <SwapHorizIcon color="primary" fontSize="large" />,
      title: dataengineeringT("dataService6Title"),
      desc: dataengineeringT("dataService6Desc")
    }
  ];

  const benefits = [
    dataengineeringT("dataBenefit1"),
    dataengineeringT("dataBenefit2"),
    dataengineeringT("dataBenefit3"),
    dataengineeringT("dataBenefit4"),
    dataengineeringT("dataBenefit5")
  ];

  return (
    <Box sx={{ overflow: "hidden", background: "transparent" }}>
      <Box
        sx={{
          flex: 1,
          pt: { xs: 1, md: 2 },
          mb: { xs: 12, md: 4 },
          backdropFilter: "blur(10px)",
          background: `
            linear-gradient(90deg, #f8fafc 0%, transparent 25%),
            linear-gradient(270deg, #f8fafc 0%, transparent 25%),
            linear-gradient(180deg, cadetblue 0%, transparent 80%)
          `,
          height: { xs: "100px", md: "200px" },
          textAlign: "center",
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h2" sx={{ pb: { xs: 2 } }}>
            {dataengineeringT("dataHeroTitle")}
          </Typography>
          <Typography variant="h6" sx={{ mx: "auto", opacity: 0.9, textAlign: "justify" }} pl={2}>
            {dataengineeringT("dataHeroDescription")}
          </Typography>
        </Container>
      </Box>

      <Container sx={{ pt: { xs: 32, md: 4 }, pb: { xs: 4 } }}>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": { transform: "translateY(-6px)", boxShadow: 4 },
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Box sx={{ mb: { xs: 1, md: 2 } }}>{service.icon}</Box>
                  <Typography variant="h5" sx={{ pb: 1 }}>
                    {service.title}
                  </Typography>
                  <Typography variant="h6" textAlign={"center"} pb={2} pl={2} pr={2} lineHeight={1.8}>
                    {service.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Why Choose Us Section */}
      <Box sx={{ backgroundColor: "transparent", py: { xs: 4, md: 8 } }}>
        <Container maxWidth="lg">
          <Box sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
          }}>
            {/* Left side: Text */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="h3">
                {dataengineeringT("dataWhyChooseTitle")}
              </Typography>
              <List dense>
                {benefits.map((benefit, index) => (
                  <ListItem key={index} sx={{ px: 0, py: 1 }}>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={benefit} />
                  </ListItem>
                ))}
              </List>
            </Box>

            {/* Right side: Image */}
            <Box sx={{
              flex: 1,
              display: { xs: "none", md: "block" }
            }}>
              <img
                src="/logos/dataeng.png"
                alt={dataengineeringT("dataImageAlt")}
                style={{
                  width: "100%",
                  maxWidth: "600px",
                  height: "auto",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, transparent 0%, cadetblue 100%)"
                }}
              />
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}